// src/api/axios.js

import axios from 'axios';
import { successNotification, warnNotification } from './util';
import router from '../router'


function getToken() {
  const token = window.sessionStorage.getItem("token");
  return token || "";
}

// 创建 Axios 实例
const service = axios.create({
  baseURL: "https://manage.tcglfx.com",
  // baseURL: "http://127.0.0.1:6655",
  timeout: 5000, // 请求超时时间
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    if (config.url !== "/login" && config.url !== "/register" && config.url !== "/signUp") {
      //这里我们可以设置token
      const token = getToken();
      if (token) {
        config.headers["Authorization"] = token;
        if (config.url !== "/api/v1/uploadFile") {
          config.headers["Content-Type"] = "application/json;charset=UTF-8";
        } else {

        }
      } else {
        warnNotification("请登录")
        router.push('/Sign-In');
      }
    }
    return {
      ...config,
      validateStatus: (status) => {
        //这里我们设置状态码的判断条件，如果返回的状态码在200到300之间就表示请求成功，否则就是失败
        return (status >= 200 && status < 300) || status === 401;
      },
    };
  },
  error => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 根据不同的状态码进行不同的处理
    switch (response.data.code) {
      case -1:
        warnNotification(response.data.msg)
        break;
      case 501:
        // 未授权，跳转到登录页面
        router.push('/Sign-In');
        break;
      case 999:
        warnNotification(response.data.msg)
        break;
      default:
        return response.data;
    }
  },
  error => {
    // 根据不同的状态码进行不同的处理
    if (error.response) {
      switch (error.response.status) {
        case 404:
          // 资源未找到
          console.error('请求的资源不存在');
          break;
        default:
          console.error('请求失败', error.response.data);
      }
    } else if (error.request) {
      // 请求已发出，但没有收到响应
      console.error('请求超时或网络错误', error.request);
    } else {
      // 其他错误
      console.error('请求配置错误', error.message);
    }
    return Promise.reject(error);
  }
);

export default service;
